export var blobToFile = function (blob, fileName) {
    var file = blob;
    file.lastModifiedDate = new Date();
    file.name = fileName;
    return file;
};
